import {
  getActiveEventsList,
  getChainsList,
  getClosedEventsList,
  getDowntimeMotivesList,
  getEventsList,
  getEventsStatsList,
  getFeaturePermission,
  getMetricsOptionsList,
  getMonitorMetricsData,
  getRealTimeData,
  getRobotDailyCountList,
  getRobotsOverviewList,
  getRobotStatesList,
  getSpecificMetricInfo,
  isLoadingChains,
  isLoadingDowntimeMotives,
  isLoadingEventsStats,
  isLoadingMetricData,
  isLoadingMonitorMetricsData,
  isLoadingNavigationStats,
  isLoadingNavigationStatuses,
  isLoadingRobotDailyCount,
  isLoadingRobotsOverview,
  isLoadingRobotStates,
  navigationOptions,
  navigationStats,
  navigationStatuses,
} from 'core/selectors';
import {
  checkFeaturePermission,
  getChains,
  getNavigationStatus,
} from 'core/slices/backend';
import {
  getMetricsOptions,
  getMonitorMetrics,
  getNavigationStats,
  getRealTimeMetrics,
  getSpecificMetric,
} from 'core/slices/dashboardMetrics';
import { getEvents, getEventsStats } from 'core/slices/event';
import {
  getDowntimeMotivesData,
  getRobotDailyCountData,
  getRobotsOverviewData,
  getRobotStatesData,
} from 'core/slices/robotStatus';
import { setSnackAlert } from 'core/slices/snackAlert';
import { connect } from 'react-redux';
import DashboardView from '../../../components/home/DashboardView';

export default connect(
  (state) => ({
    chainsList: getChainsList(state),
    isLoadingChains: isLoadingChains(state),
    metricsOptions: getMetricsOptionsList(state),
    specificMetricData: getSpecificMetricInfo(state),
    isLoadingMetricData: isLoadingMetricData(state),
    navOptions: navigationOptions(state),
    realTimeData: getRealTimeData(state),
    eventsList: getEventsList(state),
    activeEventsList: getActiveEventsList(state),
    closedEventsList: getClosedEventsList(state),
    featurePermissionResponse: getFeaturePermission(state),
    monitorMetricsData: getMonitorMetricsData(state),
    isLoadingMonitorMetricsData: isLoadingMonitorMetricsData(state),
    isLoadingNavigationStats: isLoadingNavigationStats(state),
    navigationStats: navigationStats(state),
    navigationStatuses: navigationStatuses(state),
    isLoadingNavigationStatuses: isLoadingNavigationStatuses(state),
    robotsOverviewList: getRobotsOverviewList(state),
    isLoadingRobotsOverview: isLoadingRobotsOverview(state),
    downtimeMotivesList: getDowntimeMotivesList(state),
    isLoadingDowntimeMotivesList: isLoadingDowntimeMotives(state),
    robotStatesData: getRobotStatesList(state),
    isLoadingRobotStatesData: isLoadingRobotStates(state),
    robotCountData: getRobotDailyCountList(state),
    isLoadingRobotDailyCount: isLoadingRobotDailyCount(state),
    eventsStats: getEventsStatsList(state),
    isLoadingEventsStats: isLoadingEventsStats(state),
  }),
  {
    getChains,
    getSpecificMetric,
    getMetricsOptions,
    getRealTimeMetrics,
    getEvents,
    checkFeaturePermission,
    getMonitorMetrics,
    getNavigationStats,
    getNavigationStatus,
    setSnackAlert,
    getRobotsOverviewData,
    getDowntimeMotivesData,
    getRobotStatesData,
    getRobotDailyCountData,
    getEventsStats,
  }
)(DashboardView);
